import React, { useMemo } from 'react';
import {
  RENDERER_VERSION,
  renderPageHtml
} from '@tiny-fox/storybook-renderer';
import { Page } from '../types/storybook';
import { getImageUrl } from '../utils/api';

interface CanonicalPageRendererProps {
  page: Page;
  canvasSize: string;
  className?: string;
  ariaLabel?: string;
  testId?: string;
  resolveImageUrl?: (url: string) => string;
}

/**
 * Static, production-faithful page rendering. The editor interaction layer,
 * thumbnails, previews, and PDF services all consume this same renderer
 * contract; selection handles are deliberately kept outside this component.
 */
const CanonicalPageRenderer: React.FC<CanonicalPageRendererProps> = ({
  page,
  canvasSize,
  className = '',
  ariaLabel,
  testId,
  resolveImageUrl = getImageUrl
}) => {
  const markup = useMemo(() => renderPageHtml(page, {
    canvasSize,
    resolveImageUrl: (url: string) => resolveImageUrl(url),
    className,
    ariaLabel: ariaLabel || `Storybook page ${page.pageNumber}`
  }), [ariaLabel, canvasSize, className, page, resolveImageUrl]);

  return (
    <div
      className="canonical-page-host"
      data-testid={testId}
      data-renderer-version={RENDERER_VERSION}
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
};

export default CanonicalPageRenderer;
